import { n as r } from "./property-9daa16cd.mjs";
import { i as m, E as h, x as a, a as g, r as b } from "./createReactComponent-58f9bea8.mjs";
import { e as x } from "./class-map-2994e95e.mjs";
import { r as p } from "./icon-c572aa57.mjs";
import { r as v } from "./tooltip-cb602d1f.mjs";
const u = m`
  :host {
    --exo-component-segmented-control-width: auto;
  }

  :host .segmented-control--element {
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-x-small);
    color: var(--exo-color-font-tertiary);
    font: var(--exo-text-label-standard);
    display: flex;
    gap: var(--exo-spacing-2x-small);
    white-space: nowrap;
    align-items: center;
    justify-content: center;
    width: var(--exo-component-segmented-control-width);
    min-height: var(--exo-spacing-x-large);
  }

  :host .segmented-control--element ex-icon {
    color: var(--exo-color-background-deselected);
  }

  :host .segmented-control--element:hover ex-icon {
    color: var(--exo-color-background-deselected-hover);
  }

  :host .segmented-control--white.segmented-control--element-inner,
  :host .segmented-control--gray.segmented-control--element-inner {
    border-radius: var(--exo-spacing-none);
  }

  :host
    .segmented-control--white.segmented-control--element-inner.segmented-control--item-selected:hover {
    background: var(--exo-color-background-selected-weak);
  }

  :host button.segmented-control--element-first,
  :host .segmented-control--element-first button {
    border-radius: var(--exo-radius-standard) 0 0 var(--exo-radius-standard);
  }

  :host .segmented-control--element-last {
    border-radius: 0 var(--exo-radius-standard) var(--exo-radius-standard) 0;
  }

  :host .segmented-control--white {
    background: var(--exo-color-background-action-secondary);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
  }

  :host .segmented-control--gray {
    background: var(--exo-color-background-secondary);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border-secondary);
  }

  :host .segmented-control--element:hover {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-action-hover);
    background: var(--exo-color-background-action-hover-weak);
    color: var(--exo-color-background-action-hover);
    outline: 0;
    cursor: pointer;
  }

  :host .segmented-control--element:focus-visible {
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    background: var(--exo-color-background-action-hover-weak);
    color: var(--exo-color-background-action-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
  }

  :host .segmented-control--element:disabled {
    color: var(--exo-color-background-disabled);
    pointer-events: none;
  }

  :host .segmented-control--element:disabled ex-icon {
    color: var(--exo-color-background-disabled);
  }

  :host .segmented-control--item-selected {
    background: var(--exo-color-background-selected-weak);
    color: var(--exo-color-background-selected);
  }

  :host .segmented-control--item-selected:hover {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected);
    color: var(--exo-color-background-selected-hover);
    background: var(--exo-color-background-selected-weak);
  }

  :host .segmented-control--item-selected:focus-visible {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
    background: var(--exo-color-background-selected-weak);
  }

  :host .segmented-control--item-selected ex-icon {
    color: var(--exo-color-background-selected);
  }

  :host .segmented-control--item-selected:hover ex-icon,
  :host .segmented-control--item-selected:focus-visible ex-icon {
    color: var(--exo-color-background-selected-hover);
  }

  :host .segmented-control--item-selected.segmented-control--gray {
    border-color: var(--exo-color-border-secondary);
    background: var(--exo-color-background);
  }

  :host .segmented-control--item-selected.segmented-control--gray:hover {
    border-color: var(--exo-color-background-selected);
  }

  :host
    .segmented-control--item-selected.segmented-control--gray:focus-visible {
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    color: var(--exo-color-background-selected-hover);
  }
`;
var k = Object.defineProperty, y = Object.getOwnPropertyDescriptor, n = (e, o, c, l) => {
  for (var i, s = l > 1 ? void 0 : l ? y(o, c) : o, d = e.length - 1; d >= 0; d--)
    (i = e[d]) && (s = (l ? i(o, c, s) : i(s)) || s);
  return l && s && k(o, c, s), s;
}, w = ((e) => (e.WHITE = "white", e.GRAY = "gray", e))(w || {}), f = ((e) => (e.INNER = "inner", e.FIRST = "first", e.LAST = "last", e))(f || {}), $ = ((e) => (e.TOP = "top", e.BOTTOM = "bottom", e))($ || {});
class t extends h {
  constructor() {
    super(...arguments), this.label = "", this.tooltiptext = "", this.icon = "", this.segmentPlace = "inner", this.segmentVariant = "white", this.selected = !1, this.disabled = !1, this.tooltipPlacement = "top", this.truncateLabel = () => {
      let { label: o } = this;
      return o.length > 16 && (this.tooltiptext || (this.tooltiptext = o), o = `${o.substring(0, 16)}...`), o;
    };
  }
  handleSelection() {
    const o = new CustomEvent("onSelection", { bubbles: !0, cancelable: !1, composed: !0 });
    this.dispatchEvent(o);
  }
  handlePress(o) {
    o.key === "Enter" && this.handleSelection();
  }
  getPlaceClassName() {
    return `segmented-control--element-${this.segmentPlace}`;
  }
  getVariantClassName() {
    return `segmented-control--${this.segmentVariant}`;
  }
  getIcon() {
    return this.icon ? a`<ex-icon
        icon="${this.icon}"
        size="XS"
        hide-browser-tooltip
      ></ex-icon>` : g;
  }
  getLabel() {
    return this.label ? a`${this.label}` : g;
  }
  getButtonHtml() {
    return a`
      <button
        slot="anchor"
        ?disabled=${this.disabled}
        aria-disabled=${this.disabled}
        aria-selected=${this.selected}
        @click=${this.handleSelection}
        @keydown=${this.handlePress}
        class=${x({ "segmented-control--element": !0, [this.getPlaceClassName()]: !0, [this.getVariantClassName()]: !0, "segmented-control--item-selected": this.selected })}
        part="segment"
      >
        ${this.getIcon()} ${this.getLabel()}
      </button>
    `;
  }
  getTooltipHtml() {
    return a`
      <ex-tooltip position="${this.tooltipPlacement}" alignment="middle">
        <div>${this.tooltiptext}</div>
        ${this.getButtonHtml()}
      </ex-tooltip>
    `;
  }
  render() {
    return this.label = this.truncateLabel(), this.tooltiptext && !this.disabled ? this.getTooltipHtml() : this.getButtonHtml();
  }
}
t.styles = u, n([r({ type: String })], t.prototype, "label", 2), n([r({ type: String })], t.prototype, "tooltiptext", 2), n([r({ type: String })], t.prototype, "icon", 2), n([r({ type: String })], t.prototype, "segmentPlace", 2), n([r({ type: String })], t.prototype, "segmentVariant", 2), n([r({ type: Boolean })], t.prototype, "selected", 2), n([r({ type: Boolean })], t.prototype, "disabled", 2), n([r({ type: String })], t.prototype, "tooltipPlacement", 2);
const H = (e = "") => {
  b("ex-segmentedcontrol", t, e), p(e), v(e);
};
export {
  f as S,
  w as a,
  $ as b,
  t as c,
  H as r
};
